import React, { useEffect, useState } from "react";
import { ArrowDown } from "assets/icons/Icons";
import _ from "lodash";

import TextField from "components/Recipes/RecipeSummary/TextField";
import DropzoneUI from "components/Recipes/RecipeSummary/Dropzone";
import MultiSelect from "components/Common/MultiSelect";
import Select from "react-select";

const TrafickingSheetMain = ({
  recipe,
  recipeId,
  metadata,
  fieldValues,
  setFieldValues,
  filesToUpload,
  setFilesToUpload,
}: any) => {
  const [selectedDestinations, setSelectedDestinations] = useState([]);
  const [selectedCommand, setSelectedCommand] = useState(fieldValues[0] ? fieldValues[0]["command"] : "generateConfigSheet");
  const [selectedTab, setSelectedTab] = useState("");

  const [open, setOpen] = useState(true);
  const [isCmUpload, setIsCmUpload] = useState(
    fieldValues[0] ? fieldValues[0]["isCmUpload"] : false
  );

  // const currentUserID = useSelector((state: any) => state.auth.user.userID);
  // const [xlsSheet, setXlsSheet] = React.useState([]);
  // const [finalXlsSheet, setFinalXlsSheet] = React.useState([]);
  // const [finalTraffickingSheet, setFinalTraffickingSheet] = React.useState([]);
  // const [assetFiles, setAssetFiles] = React.useState([]);
  // const [assetNames, setAssetNames] = useState([]);
  // const [placementMetadata, setPlacementMetadata] = useState({});
  // const [isSheetuploaded, setIsSheetuploaded] = useState(false);

  // const [finalSheetURL, setFinalSheetURL] = useState("");

  return (
    <div className="rounded-[10px] shadow-ingreSummaryBox bg-white py-5 px-7">
      {fieldValues.length > 0 ? (
        <>
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setOpen(!open)}
          >
            <div className="flex gap-16">
              <p className="font-bold text-lg">{metadata.title}</p>
            </div>
            <ArrowDown />
          </div>
          {open && (
            <div className="text-primary mt-3 my-6">
              <p className="font-normal text-sm">{metadata.description}</p>
              <div className="flex flex-col justify-center w-full border border-primary rounded-xl p-3 my-8">
                {metadata?.instructions?.map((instruction: any, index: any) => (
                  <div key={index} className="flex flex-row items-center my-2">
                    <div className="flex justify-center items-center w-8 h-8 rounded-full bg-slate-300 mr-5">
                      <p>{index}</p>
                    </div>
                    <div
                      className="[&_a]:text-[#003366] [&_a]:font-medium"
                      dangerouslySetInnerHTML={{ __html: `${instruction}` }}
                    />
                  </div>
                ))}
              </div>
              <TextField
                type={"string"}
                label={"CM360 Profile ID"}
                fieldData={{
                  fieldValues: _.cloneDeep(fieldValues),
                  setFieldValues: setFieldValues,
                  index: 0,
                  fieldName: "cmProfileId",
                  description: "CM360 Profile ID of the user",
                }}
              />
              <TextField
                type={"string"}
                label={"CM360 Advertiser ID"}
                fieldData={{
                  fieldValues: _.cloneDeep(fieldValues),
                  setFieldValues: setFieldValues,
                  index: 0,
                  fieldName: "cmAdvertiserId",
                  description: "CM360 Advertiser ID to create all entities",
                }}
              />
              <TextField
                type={"string"}
                label={"New CM360 Campaign Name"}
                fieldData={{
                  fieldValues: _.cloneDeep(fieldValues),
                  setFieldValues: setFieldValues,
                  index: 0,
                  fieldName: "cmCampaignName",
                  description: "Name of the new Campaign to be created in CM360",
                }}
              />
              <TextField
                type={"string"}
                label={"CM360 Landing Page ID"}
                fieldData={{
                  fieldValues: _.cloneDeep(fieldValues),
                  setFieldValues: setFieldValues,
                  index: 0,
                  fieldName: "cmLandingPageId",
                  description: "CM360 Landing Page ID for Campain.",
                }}
              />
              <div className="flex justify-between">
                <div
                  className={`${selectedCommand === 'generateConfigSheet' ? 'bg-[#014BB2]' : 'bg-[#0177FB]'} text-white rounded-xl py-2 px-4 cursor-pointer`}
                  onClick={() => {
                    setSelectedCommand("generateConfigSheet");
                    let tempFieldValues = _.cloneDeep(fieldValues);
                    tempFieldValues[0]["command"] = "generateConfigSheet";
                    setFieldValues(tempFieldValues);
                  }}
                >
                  STEP 1: Generate Configuration Sheet
                </div>
                <div
                  className={`${selectedCommand === 'generateFinalTraffickingSheet' ? 'bg-[#014BB2]' : 'bg-[#0177FB]'} text-white rounded-xl py-2 px-4 cursor-pointer`}
                  onClick={() => {
                    setSelectedCommand("generateFinalTraffickingSheet");
                    let tempFieldValues = _.cloneDeep(fieldValues);
                    tempFieldValues[0]["command"] = "generateFinalTraffickingSheet";
                    setFieldValues(tempFieldValues);
                  }}
                >
                  STEP 2: Generate Final Trafficking Sheet
                </div>
                <div
                  className={`${selectedCommand === 'UploadEntitesToCM360' ? 'bg-[#014BB2]' : 'bg-[#0177FB]'} text-white rounded-xl py-2 px-4 cursor-pointer`}
                  onClick={() => {
                    setSelectedCommand("UploadEntitesToCM360");
                    let tempFieldValues = _.cloneDeep(fieldValues);
                    tempFieldValues[0]["command"] = "UploadEntitesToCM360";
                    setFieldValues(tempFieldValues);
                  }}
                >
                  STEP 3: Upload All Entities to CM360
                </div>
              </div>

              {selectedCommand === "UploadEntitesToCM360" && (
                <div className="flex flex-col my-4">
                  <DropzoneUI
                    label={"traffickingSheetAsset"}
                    text={"Input text"}
                    fieldData={{
                      fieldValues: fieldValues,
                      setFieldValues: setFieldValues,
                      index: 0,
                      fieldName: "traffickingSheetAsset",
                      description: "Upload Final Trafficking Sheet to generate entities in CM360",
                    }}
                    filesToUpload={filesToUpload}
                    setFilesToUpload={setFilesToUpload}
                    recipeId={recipeId}
                    recipe={recipe}
                  />
                </div>
              )}
              {selectedCommand === "generateFinalTraffickingSheet" && (
                <DropzoneUI
                  label={"configSheetAsset"}
                  text={"Input text"}
                  fieldData={{
                    fieldValues: fieldValues,
                    setFieldValues: setFieldValues,
                    index: 0,
                    fieldName: "configSheetAsset",
                    description: "Upload updated Config Sheet",
                  }}
                  filesToUpload={filesToUpload}
                  setFilesToUpload={setFilesToUpload}
                  recipeId={recipeId}
                  recipe={recipe}
                />
              )}
              {selectedCommand === "generateConfigSheet" && (
                <>
                  <div className="flex flex-col my-4">
                    <DropzoneUI
                      label={"creativeAsset"}
                      text={"Input text"}
                      fieldData={{
                        fieldValues: fieldValues,
                        setFieldValues: setFieldValues,
                        index: 0,
                        fieldName: "creativeAsset",
                        description: "Upload Creative Assets to be upload to CM360",
                      }}
                      filesToUpload={filesToUpload}
                      setFilesToUpload={setFilesToUpload}
                      recipeId={recipeId}
                      recipe={recipe}
                    />
                  </div>
                  <p className="font-semibold mr-2 mt-4 min-w-max text-sm">Select Destinations</p>
                  <MultiSelect
                    placeholderText="Please Select Destinations"
                    options={["PRISMA", "DV360", "Meta"]}
                    selected={fieldValues[0]["supportedDestinations"]}
                    onChange={(e) => {
                      let tempFieldValues = _.cloneDeep(fieldValues);
                      tempFieldValues[0]["supportedDestinations"] = e;
                      setFieldValues(tempFieldValues);
                    }}
                    setSelected={setSelectedDestinations}
                    width={"w-full"}
                  />

                  <div className="flex border-b border-slate-400 mt-6">
                    <div
                      onClick={() =>
                        fieldValues[0]["supportedDestinations"].includes("PRISMA")
                          ? setSelectedTab("PRISMA")
                          : null
                      }
                      className={`tab-button px-4 py-2 
                        ${
                          fieldValues[0]["supportedDestinations"].includes("PRISMA")
                            ? "cursor-pointer hover:bg-[#f3f4f6] hover:text-[#2563EB] hover:border-[#2563EB]"
                            : "cursor-default"
                        }
                        ${
                          fieldValues[0]["supportedDestinations"].includes("PRISMA") &&
                          selectedTab === "PRISMA"
                            ? "text-[#2563EB] bg-[#e5e7eb] border-[#2563EB] shadow-md rounded-t-lg"
                            : "text-gray-600 bg-white border-transparent"
                        }
                        border-b-2 focus:outline-none transition-all duration-200 rounded-t-lg`}
                    >
                      PRISMA Sheet
                    </div>
                    <div
                      onClick={() =>
                        fieldValues[0]["supportedDestinations"].includes("DV360")
                          ? setSelectedTab("DV360")
                          : null
                      }
                      className={`cursor-pointer tab-button px-4 py-2 
                        ${
                          fieldValues[0]["supportedDestinations"].includes("DV360")
                            ? "cursor-pointer hover:bg-[#f3f4f6] hover:text-[#2563EB] hover:border-[#2563EB]"
                            : "cursor-default"
                        }
                        ${
                          fieldValues[0]["supportedDestinations"].includes("DV360") &&
                          selectedTab === "DV360"
                            ? "text-[#2563EB] bg-[#e5e7eb] border-[#2563EB] shadow-md rounded-t-lg"
                            : "text-gray-600 bg-white border-transparent"
                        } 
                      border-b-2 border-transparent focus:outline-none`}
                    >
                      DV360
                    </div>
                    <div
                      onClick={() =>
                        fieldValues[0]["supportedDestinations"].includes("Meta")
                          ? setSelectedTab("Meta")
                          : null
                      }
                      className={`tab-button px-4 py-2 
                        ${
                          fieldValues[0]["supportedDestinations"].includes("Meta")
                            ? "cursor-pointer hover:bg-[#f3f4f6] hover:text-[#2563EB] hover:border-[#2563EB]"
                            : "cursor-default"
                        }
                        ${
                          fieldValues[0]["supportedDestinations"].includes("Meta") &&
                          selectedTab === "Meta"
                            ? "text-[#2563EB] bg-[#e5e7eb] border-[#2563EB] shadow-md rounded-t-lg"
                            : "text-gray-600 bg-white border-transparent"
                        } 
                      border-b-2 border-transparent focus:outline-none`}
                    >
                      Meta
                    </div>
                  </div>
                  {selectedTab === "PRISMA" && (
                    <div>
                      <div className="flex flex-col my-4">
                        <DropzoneUI
                          label={"placementSheetAsset"}
                          text={"Input text"}
                          fieldData={{
                            fieldValues: fieldValues,
                            setFieldValues: setFieldValues,
                            index: 0,
                            fieldName: "placementSheetAsset",
                            description: "Upload Placement Sheet",
                          }}
                          filesToUpload={filesToUpload}
                          setFilesToUpload={setFilesToUpload}
                          recipeId={recipeId}
                          recipe={recipe}
                        />
                      </div>
                      <TextField
                        type={"string"}
                        label={"Placement Name Pattern"}
                        placeholder={
                          "Channel Site>>Id>>Quarter>>Objective>>Action Type>>Target KPI>>Targeting Scope>>Language>>Size>>(Digital)>>Channel Nature"
                        }
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "PlacementPattern",
                          description: "Placement Pattern for you Placement Names",
                        }}
                      />
                    </div>
                  )}
                  {selectedTab === "DV360" && (
                    <div>
                      <TextField
                        type={"string"}
                        label={"DV360 Partner ID"}
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "dvPartnerId",
                          description: "DV360 Partner ID to create all entities",
                        }}
                      />
                      <TextField
                        type={"string"}
                        label={"DV360 Advertiser ID"}
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "dvAdvertiserId",
                          description: "DV360 Advertiser ID to create all entities",
                        }}
                      />
                      <TextField
                        type={"string"}
                        label={"DV360 Insertion Order IDs"}
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "dvInsertionOrders",
                          description:
                            "Comma separated DV360 Insertion Order IDs to create all entities",
                        }}
                      />
                    </div>
                  )}
                  {selectedTab === "Meta" && (
                    <div>
                      <TextField
                        type={"string"}
                        label={"Meta Developer Token"}
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "metaDevToken",
                          description: "Meta Developer Token to call the Meta API",
                        }}
                      />
                      <TextField
                        type={"string"}
                        label={"Meta Campaign ID"}
                        fieldData={{
                          fieldValues: _.cloneDeep(fieldValues),
                          setFieldValues: setFieldValues,
                          index: 0,
                          fieldName: "metaCampaignId",
                          description: "Meta Campaign ID to fetch Ads and Ad Sets",
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          )}{" "}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TrafickingSheetMain;
